import { getLangCookie, setLangCookie } from 'src/utils/cookie';
import { updateLanguage } from 'src/modules/shared/context/actions';
import ButtonDropdown from 'src/components/buttons/buttonDropdown/buttonDropdown';
import { DropdownItem } from 'reactstrap';
import i18n from 'src/utils/translate';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { Lang } from 'src/types';

const LANGUAGES: {[key: string]: string} = {
  'en': 'English',
  'es': 'Español',
  'pt': 'Português',
};

export default function LanguageChange() {
  const dispatch = useDispatch();
  const router = useRouter();


  const onChange = async (lang: Lang) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setLangCookie(lang);
    await dispatch(updateLanguage(lang));
    i18n.changeLanguage(lang);
    router.replace(window.location.pathname + window.location.search + window.location.hash);
  };

  return (
    <ButtonDropdown
      color="languages"
      text={`${i18n.t('Language')}: ${LANGUAGES[getLangCookie()]}`}
    >
      {Object.keys(LANGUAGES).map(language => (
        <DropdownItem
          key={language}
          onClick={() => onChange(language as Lang)}
        >
          {LANGUAGES[language]}
        </DropdownItem>
      ))}
    </ButtonDropdown>
  );
}
